import styled from 'styled-components'
import CloseButton from '@/components/close-button'
import { createModal, useModalize } from '@/components/modalize'
import { breakpoints, colors, fontWeights } from '@/styles'
import htmlToReact from '@/utils/html-to-react'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 30px;
  position: relative;

  @media (max-width: ${breakpoints.phoneMax}) {
    padding: 60px 20px 50px;
  }
`

const Title = styled.h1`
  font-size: 24px;
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.2px;
  line-height: 33px;
  text-align: center;
  margin-bottom: 20px;
`

const Text = styled.p`
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  max-width: 325px;
  margin: 0;

  a {
    color: ${colors.regular};
    text-decoration: underline;
  }
`

const HelperModal = ({ title = '', description = '' }) => {
  const { close } = useModalize()
  return (
    <Wrapper
      role="dialog"
      aria-labelledby="helper-dialog-title"
      aria-describedby="helper-dialog-message"
    >
      <CloseButton onClick={close} />
      <Title id="helper-dialog-title">{title}</Title>
      <Text id="helper-dialog-message">{htmlToReact(description)}</Text>
    </Wrapper>
  )
}

export const show = createModal(HelperModal, {
  width: '465px',
  mobileFullscreen: true
})
